import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  transform(items: any[], field: any, value: any): any {
    return field && value !== null && value !== '' && items ? items.filter(item => item[field].indexOf(value) !== -1) : items;
  }
}
